import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Divider } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HeaderDispatch from './model';


class Header extends React.Component<{}>{
    render() {
        let dispatcher: HeaderDispatch = (this.props as any).dispatcher

        return (
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="fixed">
                    <Toolbar>
                        {/* <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton> */}
                        <Typography variant="h6" component="div" sx={{ mr: 2, fontFamily: 'font-farsi-logo' }}>
                            ویـــلاگــــرام
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ flexGrow: 1, mr: 2 }}>
                            : آگهی فیک نداریم
                        </Typography>

                        <Button startIcon={<SearchIcon sx={{ ml: 1 }} />} color="inherit" onClick={() => {
                            dispatcher.filter()
                        }}>
                            جستجو
                        </Button>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                        <Button color="inherit" onClick={() => {
                            dispatcher.bookmark()
                        }}>ذخیره شده ها</Button>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                        <Button color="inherit" onClick={() => {
                            dispatcher.seen()
                        }}>آخرین بازدید ها</Button>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                        <Button color="inherit" onClick={() => {
                            dispatcher.moshaveran()

                        }}>مشاوران</Button>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                        <Button color="inherit">ویلا برای فروش دارید ؟</Button>
                        <Divider orientation="vertical" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />

                        <Button color="inherit">درباره ما</Button>


                    </Toolbar>
                </AppBar>
            </Box>
        )
    }
}

export default Header